// https://medium.com/@sub.metu/angular-fallback-for-broken-images-5cd05c470f08
import { Directive, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Directive({
    selector: 'img[placeholder]',
    host: {
        '(error)': 'onError()',
        '(load)': 'onLoad()',
        '[src]': 'src'
    },
    standalone: true
})
/**
 * Shows a placeholder image in case the image source fails to load
 */
export class ImagePlaceholderDirective {

  /** Image source to load */
  @Input() src: string | SafeUrl;

  /** Placeholder to show on failure */
  @Input() placeholder: string | SafeUrl;

  /** Handler for image loaded. */
  @Output() srcImageLoadedEventHandler: EventEmitter<void> = new EventEmitter();

  /** Handler for image failed to load. */
  @Output() srcImageFailedToLoadEventHandler: EventEmitter<void> = new EventEmitter();

  constructor(
    protected renderer: Renderer2,
    protected hostElement: ElementRef
  ) {}

  onError() {
    this.src = this.placeholder;
    this.srcImageFailedToLoadEventHandler.emit();
  }

  onLoad() {
    this.renderer.addClass(this.hostElement.nativeElement, 'image-loaded');

    if (this.src !== this.placeholder) {
      this.srcImageLoadedEventHandler.emit();
    }
  }
}
